import { brand } from "../../../../branchAndBrandSpecific/utils/brandVariables/brandVariables";
import battlenetLogo from "../assets/auth-bnet.svg";
import steamLogo from "../assets/auth-steam.svg";
import discordLogo from "../assets/auth-discord.svg";
import twitchLogo from "../assets/auth-twitch.svg";

export interface authOptionProps {
  logo: string;
  suffix: string;
  longText: string;
  shortText: string;
}

export const authOptions: authOptionProps[] = [
  brand.hasAuth.steam
    ? {
        logo: steamLogo,
        suffix: "steam",
        longText: "STEAM",
        shortText: "STEAM",
      }
    : null,
  brand.hasAuth.bnet
    ? {
        logo: battlenetLogo,
        suffix: "bnet",
        longText: "Battle.net",
        shortText: "Battle.net",
      }
    : null,
  brand.hasAuth.discord
    ? {
        logo: discordLogo,
        suffix: "discord",
        longText: "Discord",
        shortText: "discord",
      }
    : null,
  brand.hasAuth.twitch
    ? {
        logo: twitchLogo,
        suffix: "twitch",
        longText: "Twitch",
        shortText: "twitch",
      }
    : null,
].filter(Boolean) as authOptionProps[];
